import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { VehicleInfo } from '../models/vehicle-info';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InfocarDaTarga } from '../dto/infocar-da-targa';
import { map, catchError } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { VehicleVersion } from '../models/vehicle-version';

@Injectable({
  providedIn: 'root'
})
export class BadaService {
  vehicleInfo = new BehaviorSubject<VehicleInfo>(null);
  vehicleVersionSelected: VehicleVersion;

  constructor(private http: HttpClient, private loaderService: LoaderService) { }

  /**
   * Aggiorna vehicleInfo con i dati che ritornano dal servizio
   * @param newVehicleInfo
   */
  private updateVehicleInfo(newVehicleInfo: VehicleInfo): void {
    newVehicleInfo.versions.forEach(version => {
      if (version.equipments && version.equipments.length) {
        version.equipments.forEach(optional => {
          newVehicleInfo.allEquipments.some(opt => opt.code == optional.code) ? null : newVehicleInfo.allEquipments.push(optional)
        })
      }
    });
    this.vehicleInfo.next(newVehicleInfo);
  }

  /**
   * Svuota tutte le vehicleInfo
   */
  private clearVehicleInfo(): void {
    this.vehicleInfo.next(null);
  }


  /**
   * Restituisce le informazioni del veicolo e le verisoni
   * @param vehiclePlate
   */
  getInfocarDaTarga(vehiclePlate: string) {
    this.clearVehicleInfo();
    const url = `${BASE_API_URL}InfocarDaTarga?targa=${vehiclePlate}`;
    const headers = new HttpHeaders().set('Authorization', AUTH_TOKEN);
    return this.http.get<InfocarDaTarga>(url, { headers: headers }).pipe(
      catchError(err => of(`${err}`)),
      map((info: any) => {
        this.updateVehicleInfo(InfocarDaTarga.InfocarDaTargaToVehicleInfoDto(info.infocarDaTarga, vehiclePlate));
      })
    )
  }

  /**
   * Restituisce le informazioni del veicolo e le verioni - TEST da file.json
   */
  getInfocarDaTargaTest(vehiclePlate: string) {
    this.clearVehicleInfo();
    return this.http.get(`assets/plates/${vehiclePlate}.json`).pipe(
    // return this.http.get('assets/plates/GB265PG.json').pipe(
      map((info: any) => {
        this.updateVehicleInfo(InfocarDaTarga.InfocarDaTargaToVehicleInfoDto(info.infocarDaTarga, vehiclePlate));
      })
    )
  }

}


const HTTP_OPTIONS =
{
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}
const BASE_API_URL = 'https://fleetservice.azurewebsites.net/api/IdentityCar/';
const AUTH_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlfYWNjZXNzIjoiYXBpX2FjY2VzcyIsIm5iZiI6MTQ5ODIyNDgwNSwiZXhwIjoyMzYyMjI0ODA1LCJpc3MiOiJzZC5GbGVldFNlcnZpY2UuYXBpIiwiYXVkIjoiaHR0cDovL3NkLmZsZWV0c2VydmljZS8ifQ.wN9NxH7K1c3h_yz-bf-xPHTzhvn4_y4echUE60Vyv1U';

